import api from '@/store/api/customer/product/number/revisions'
import * as mutationTypes from './mutation-types'
// Modules
import revision from './revision'
import {mapLegacyPagination} from '@/store/utils'

const initialState = () => ({
    revisions: {
        data: [],
        pagination: {}
    }
})

export default {
    namespaced: true,
    state: initialState(),
    getters: {
        revisions: state => state.revisions.data,
        pagination: state => state.revisions.pagination
    },
    actions: {
        /**
         * @param {{customerId: number, number: string, params: {}}} data
         * @returns {Promise<*>}
         */
        listRevisions: async ({commit, dispatch}, data) => {
            try {
                const response = await api.listRevisions(data)
                const revisions = {
                    ...response,
                    pagination: mapLegacyPagination(response.pagination)
                }

                commit(mutationTypes.SET_REVISIONS, revisions)
                return revisions
            } catch (e) {
                const errorResponse = await dispatch('errors/addErrors', [e], {root: true})
                return Promise.reject(errorResponse[0])
            }
        },
        resetRevisions: async ({commit}) => commit(mutationTypes.RESET_REVISIONS)
    },
    modules: {
        revision
    },
    mutations: {
        [mutationTypes.SET_REVISIONS]: (state, data) => state.revisions = data,
        [mutationTypes.RESET_REVISIONS]: (state) => Object.assign(state, initialState())
    }
}
